var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "main-content flex flex-col flex-grow p-4 pt-0 h-full" },
    [
      _c("Header", {
        attrs: {
          title: "Calendar",
          btnText: "Create Client",
          showBtn: "true",
          btnClass: " font-medium",
        },
        on: { "btn-clicked": _vm.handleCreateNew },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("PlusIcon", {
                  staticClass: "w-3 h-3 group-hover:text-black mr-3",
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass:
            "bg-indigo-50 flex justify-between items-center py-3 px-4 text-sm rounded-lg mb-2",
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-2 flex-wrap text-black/88" },
            [
              _c("InfoCircleFilled"),
              _vm._v(
                " Need a clearer picture of your week? Jump into the Calendar to see your visits in a weekly view. "
              ),
              _c("HoveredIcon", { staticClass: "w-3 h-3 hover-icon" }),
              _c(
                "div",
                {
                  staticClass: "text-blue ml-1 cursor-pointer",
                  on: { click: _vm.viewByWeek },
                },
                [_vm._v("View by Week")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "flex justify-between" },
        [
          _c("top-filter-item", {
            attrs: {
              schedulerView: _vm.schedulerView,
              isAdmin: _vm.isAdmin,
              currentUser: _vm.currentUser,
              filterClasses: "schedularfilter_classes",
              company: _vm.company,
              placeHolderText: _vm.placeHolderText,
            },
            on: {
              optionChange: _vm.handleOptionChange,
              toggleAdditionalFilters: _vm.toggleAdditionalFilters,
            },
          }),
          _c(
            "div",
            { staticStyle: { "align-self": "center" } },
            [
              _c("UIButton", {
                staticClass: "font-outfit",
                attrs: {
                  variant: "outline-black",
                  buttonText: "Create New Visit",
                  size: "lg",
                },
                on: { click: _vm.openActivityModal },
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function () {
                      return [_c("PlusHoveredIcon", { staticClass: "w-6 h-6" })]
                    },
                    proxy: true,
                  },
                  {
                    key: "hover-icon",
                    fn: function () {
                      return [_c("PlusHoveredIcon", { staticClass: "w-6 h-6" })]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "h-full", attrs: { id: "container" } },
        [
          _vm.showContractors
            ? _c("contractor-scheduler", {
                attrs: {
                  axisStart: _vm.dateRange.startDate,
                  axisEnd: _vm.dateRange.endDate,
                  currentUser: _vm.currentUser,
                  companyId: _vm.company.id,
                  company: _vm.company,
                  shouldClearFilters: _vm.shouldClearFilters,
                  selectedContractorsIds: _vm.selectedContractorsIds,
                  showAdditionalFilters: _vm.showAdditionalFilters,
                },
                on: {
                  close: _vm.toggleAdditionalFilters,
                  "update:updateCount": _vm.updateTotalCount,
                  updateBasicActivityData: _vm.updateBasicActivityData,
                  updateProject: _vm.updateProject,
                },
              })
            : _vm._e(),
          _vm.showManagers && _vm.isAdmin
            ? _c("manager-scheduler", {
                attrs: {
                  axisStart: _vm.dateRange.startDate,
                  axisEnd: _vm.dateRange.endDate,
                  managers: _vm.managers,
                  currentUser: _vm.currentUser,
                  selectedManagersIds: _vm.selectedManagersIds,
                  company: _vm.company,
                  companyId: _vm.company.id,
                  shouldClearFilters: _vm.shouldClearFilters,
                  showAdditionalFilters: _vm.showAdditionalFilters,
                },
                on: {
                  close: _vm.toggleAdditionalFilters,
                  updateBasicActivityData: _vm.updateBasicActivityData,
                  "update:updateCount": _vm.updateTotalCount,
                  updateProject: _vm.updateProject,
                },
              })
            : _vm._e(),
          _vm.showProjects
            ? _c("projects-scheduler", {
                staticClass: "mb-10",
                attrs: {
                  axisStart: _vm.dateRange.startDate,
                  axisEnd: _vm.dateRange.endDate,
                  currentUser: _vm.currentUser,
                  shouldClearFilters: _vm.shouldClearFilters,
                  showAdditionalFilters: _vm.showAdditionalFilters,
                  selectedProjectsIds: _vm.selectedProjectsIds,
                  companyId: _vm.company.id,
                },
                on: {
                  "update:updateCount": _vm.updateTotalCount,
                  filtersReset: _vm.handleProjectFiltersReset,
                  close: _vm.toggleAdditionalFilters,
                  updateBasicActivityData: _vm.updateBasicActivityData,
                  updateProject: _vm.updateProject,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.modalShown
        ? _c("ClientEditModal", {
            attrs: {
              dialog: _vm.modalShown,
              companyId: _vm.company.id,
              currentUserId: _vm.currentUser.id,
              currentUser: _vm.currentUser,
              activeTab: _vm.activeTab,
              initialData: {},
              isCareplanExist: false,
              isEdit: false,
              currentEditTab: _vm.currentEditTab,
            },
            on: { closeDialog: _vm.hanldeCancel, close: _vm.handleClose },
          })
        : _vm._e(),
      _vm.activityModalOpened
        ? _c("ActivityFormModal", {
            attrs: {
              currentUserRole: _vm.currentUser.role,
              companyId: _vm.company.id,
              currentUserId: _vm.currentUser.id,
              showProject: true,
            },
            on: {
              activityUpdated: _vm.onActivityListItemAdded,
              activityAdded: _vm.onActivityListItemAdded,
              close: function ($event) {
                _vm.activityModalOpened = false
              },
            },
            model: {
              value: _vm.activityModalOpened,
              callback: function ($$v) {
                _vm.activityModalOpened = $$v
              },
              expression: "activityModalOpened",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }